<div class="local-attachment-body">
  <div class="local-attachment-header">
    <div class="local-attachment-caption">{{ 'attachment_Uploading_Caption' | xsI18n }}</div>
    <!-- <sa-popover-button type="confirm" icon="icon-md hd-icon-delete"
            button-class="delete-attachment-button"
            caption="{{'popover_Confirm_Title' | xsI18n}}"
            main-content="{{'attachment_DeleteConfirmation' | xsI18n}}"
            confirm-text="{{'popover_Delete_Button' | xsI18n}}"
            on-confirm="onDelete()"
            can-edit="true">
        </sa-popover-button> -->
  </div>
  <div class="local-attachment-details">
    <div class="local-attachment-file-name">{{parentActivity.details.fileName}}</div>
    <div class="local-attachment-file-size">({{ parentActivity.details.fileSize | xsFileSizeFormatPipe }})</div>
  </div>
</div>
